<ng-template #logo>
  @if (environment.FOOTER_LOGO_COLOR === 'color') {
    <img
      class="logo display-block mr-6 mb-4 mb-0@desktop"
      height="25"
      [alt]="`${siteStore.siteName} Icon`"
      [src]="'logo-icon-color.svg' | assetUrl"
    />
  } @else {
    <img
      class="logo display-block mr-6 mb-4 mb-0@desktop"
      height="25"
      [alt]="`${siteStore.siteName} Icon`"
      [src]="'logo-icon-black.svg' | assetUrl"
    />
  }
</ng-template>

<div class="wrapper bg-vapor">
  @if (variant === 'simple') {
    <div class="display-flex align-items-center pf-6">
      @if (loggedIn$ | async) {
        <ng-container *ngTemplateOutlet="logo" />
      } @else {
        <a href="/">
          <ng-container *ngTemplateOutlet="logo" />
        </a>
      }
      <span class="color-iron t-9@r ml-auto">© {{ year }} {{ siteStore.siteName }}</span>
    </div>
  } @else {
    <div class="display-flex align-items-center ph-6 pt-8">
      <div class="flex-grow-1">
        <div class="max-width-1080 mh-auto">
          <div class="links pb-6 display-flex flex-direction-column flex-direction-row@desktop">
            <a href="/">
              <ng-container *ngTemplateOutlet="logo" />
            </a>

            <nav class="columns-2 columns-3@tablet display-flex@desktop">
              <sb-link
                class="links__item display-block t-9 color-green font-weight-500"
                [href]="countryCodeUrlPrefix + (nonCoreCountry ? '/?non_core_country=true' : '/signup')"
                [noRedirect]="!nonCoreCountry"
                (click)="onSignupClick()"
                >Free Signup</sb-link
              >
              @for (link of PRIMARY_LINKS; track link.label) {
                <sb-link
                  class="links__item display-block t-9 color-ash hover:color-black"
                  [href]="link.url"
                  [internal]="link.internal"
                >
                  {{ link.label }}
                </sb-link>
              }
            </nav>
          </div>

          <hr class="mf-0 border-top" />

          <div
            class="pv-6 display-flex flex-direction-column flex-direction-row@tablet justify-content-space-between gap-4"
          >
            <div class="color-iron t-10">© {{ year }} {{ siteStore.siteName }}</div>

            <nav class="display-flex align-items-center gap-6">
              @for (link of SOCIALS_LINKS; track link.title) {
                <a
                  class="display-flex color-iron hover:color-ash"
                  target="_blank"
                  [href]="link.url"
                  [title]="link.title"
                >
                  <i class="nc-icon i-9" [ngClass]="link.icon" [title]="link.title"></i>
                  <sb-icon [name]="link.icon" [size]="'8'" />
                </a>
              }
              <sb-link
                class="t-10 color-iron hover:color-ash text-decoration-underline cursor-pointer"
                [href]="`${countryCodeUrlPrefix}/terms-of-service`"
                [noRedirect]="true"
                (click)="openTermsModal()"
              >
                Terms
              </sb-link>
              <sb-link
                class="t-10 color-iron hover:color-ash text-decoration-underline cursor-pointer"
                [href]="`${countryCodeUrlPrefix}/privacy-policy`"
                [noRedirect]="true"
                (click)="openPrivacyModal()"
              >
                Privacy
              </sb-link>
            </nav>
          </div>
        </div>
      </div>
    </div>
  }
</div>
